<template>
    <div class="container-main">
        <div class="container-1">
            <nav class="add-navigation add_header flex-wrap flex   ">
                <div
                        @click="$router.push({ name: 'system-admin-company-list' })"
                        class="back-link my-2"
                >
                    <svg
                            class="icon"
                            width="30px"
                            height="30px"
                            viewBox="0 0 30 30"
                            version="1.1"
                    >
                        <path
                                d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                                id="path-1"
                        />
                    </svg>
                    <p>Back to Company</p>
                </div>
                <div class="buttons-wrapper flex-wrap   ">
                    <div
                            @click="$router.push({ name: 'system-admin-company-list' })"
                            class="secondary-button  my-2"
                    >
                        <secondary-button>Cancel</secondary-button>
                    </div>
                    <div class="primary-button  my-2 ">
                        <primary-button @click.native="addCompany"
                        >Add Company
                        </primary-button
                        >
                    </div>
                </div>
            </nav>
            <div class="add-container">
                <span class="container-title">Add Company</span>
                <div class="row p-3">

                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                name="company name"
                                class="field"
                                :value="company.company_name"
                                @input="handleCompanyName"
                                v-validate="'required'"
                                :class="{ input: true, 'is-danger': errors.has('company name') }"
                                placeholder="Enter company name"
                        />
                        <div class="help is-danger" v-if="errors.has('company name')">
                            {{ errors.first("company name") }}
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <primary-select
                                type="text"
                                name="reseller"
                                class="mode input"
                                v-model="company.reseller_uuid"
                                placeholder="Select reseller"
                                :options="resellers"
                        />
                    </div>
                    <div class="col-md-6 col-12">
                        <primary-input
                                name="email"
                                type="text"
                                v-model="company.contact.email"
                                v-validate="'required|email'"
                                :class="{ input: true, 'is-danger': errors.has('email') }"
                                placeholder="Enter email"
                        />
                        <div v-if="errors.has('email')" class="help is-danger">
                            {{ errors.first("email") }}
                        </div>
                    </div>
                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                name="address"
                                v-validate="'required'"
                                v-model="company.contact.address"
                                :class="{ input: true, 'is-danger': errors.has('address') }"
                                placeholder="Enter address"
                        />
                        <div class="help is-danger" v-if="errors.has('address')">
                            {{ errors.first("address") }}
                        </div>
                    </div>

                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                name="first name"
                                v-validate="'required'"
                                :value="company.contact.first_name"
                                @input="handleFirstName"
                                :class="{ input: true, 'is-danger': errors.has('first name') }"
                                placeholder="Enter first name"
                        />
                        <div v-if="errors.has('first name')" class="help is-danger">
                            {{ errors.first("first name") }}
                        </div>
                    </div>

                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                name="last name"
                                v-validate="'required'"
                                :value="company.contact.last_name"
                                @input="handleLastName"
                                :class="{ input: true, 'is-danger': errors.has('last name') }"
                                placeholder="Enter last name"
                        />
                        <div class="help is-danger" v-if="errors.has('last name')">
                            {{ errors.first("last name") }}
                        </div>
                    </div>

                    <div class="col-md-6 col-12">

                        <primary-input
                                type="password"
                                name="password"
                                v-model="company.contact.passwd"
                                v-validate="'required'"
                                :class="{ input: true, 'is-danger': errors.has('password') }"
                                placeholder="********"
                        />
                        <div v-if="errors.has('password')" class="help is-danger">
                            {{ errors.first("password") }}
                        </div>

                    </div>

                    <div class="col-md-6 col-12">
                        <primary-select
                                type="text"
                                name="mode"
                                class="mode"
                                v-validate="'required'"
                                v-model="company.prepay"
                                :class="{ input: true, 'is-danger': errors.has('mode') }"
                                placeholder="Enter mode"
                                :options="modes"
                        />
                        <div class="help is-danger" v-if="errors.has('mode')">
                            {{ errors.first("mode") }}
                        </div>
                    </div>

                    <div class="col-md-6 col-12">
                        <primary-input
                                type="number"
                                name="sms per sec"
                                v-model="company.sms_per_sec"
                                class="input"
                                placeholder="Enter sms per sec"
                        />
                    </div>


                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                @input="PhonePatternHendler"
                                name="phone number"
                                v-model="phone_number"
                                v-validate="{required: true, regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/}"
                                :class="{ input: true, 'is-danger': errors.has('phone number') }"
                                placeholder="Enter phone number"
                        />
                        <div v-if="errors.has('phone number')" class="help is-danger">
                            {{ errors.first("phone number") }}
                        </div>
                    </div>
                    <!-- <div></div> -->
                    <!-- <div class="help is-danger" v-if="errors.has('reseller')">{{ errors.first('reseller') }}</div> -->
                    <div class="col-md-6 col-12">
                        <primary-select
                                type="text"
                                name="country"
                                class="country"
                                v-validate="'required'"
                                v-model="company.contact.country_uuid"
                                :class="{ input: true, 'is-danger': errors.has('country') }"
                                placeholder="Country"
                                :options="countries"
                        />
                        <div v-if="errors.has('country')" class="help is-danger">
                            {{ errors.first("country") }}
                        </div>
                    </div>
                    <div class="col-md-6 col-12 wrapper-buttons flex-sm-row flex-column">
                        <div class="position-relative w-100 mr-sm-2">
                            <primary-input
                                    type="text"
                                    name="state"
                                    class="state"
                                    v-validate="'required'"
                                    v-model="company.contact.state"
                                    :class="{ input: true, 'is-danger': errors.has('state') }"
                                    placeholder="state"
                            ></primary-input>
                            <div class="help is-danger" v-if="errors.has('state')">
                                {{ errors.first("state") }}
                            </div>
                        </div>
                        <div class="position-relative w-100">
                            <primary-input
                                    type="text"
                                    name="city"
                                    v-validate="'required'"
                                    v-model="company.contact.city"
                                    :class="{ input: true, 'is-danger': errors.has('city') }"
                                    placeholder="Enter city"
                            />
                            <div class="help is-danger" v-if="errors.has('city')">
                                {{ errors.first("city") }}
                            </div>
                        </div>


                    </div>
                    <div class="col-md-6 col-12">

                        <primary-input
                                type="text"
                                name="zipcode"
                                v-model="company.contact.zipcode"
                                v-validate="{required: true, numeric: true}"
                                :class="{ input: true, 'is-danger': errors.has('zipcode') }"
                                placeholder="Enter zipcode"
                        />
                        <div class="help is-danger" v-if="errors.has('zipcode')">
                            {{ errors.first("zipcode") }}
                        </div>

                    </div>
                    <div class="col-md-6 col-12">
                        <primary-input
                                type="text"
                                :name="
                company.prepay === 'false' ? 'credit limit' : 'Test credit'
              "
                                class="credit"
                                v-validate="{required: true, numeric: true}"
                                v-model="company.credit"
                                :class="{ input: true, 'is-danger': errors.has( company.prepay === 'false' ? 'credit limit' : 'Test credit') }"
                                placeholder="Credit"
                        />
                        <div class="help is-danger"
                             v-if="errors.has( company.prepay === 'false' ? 'credit limit' : 'Test credit')">
                            {{ errors.first( company.prepay === 'false' ? 'credit limit' : 'Test credit') }}
                        </div>
                        <div class="col-md-6 col-12">
                            <template v-if="company.prepay === 'false'">
                                <primary-select
                                        type="text"
                                        name="payment term"
                                        v-model="company.payment_term_uuid"
                                        :class="{
                  input: true,
                  'is-danger': errors.has('payment term'),
                }"
                                        placeholder="Payment Term"
                                        :options="payments"
                                ></primary-select>
                                <div v-if="errors.has('payment term')" class="help is-danger">
                                    {{ errors.first("payment term") }}
                                </div>
                            </template>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        components: {
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            AppDropzone: () => import("@/components/Dropzone"),
        },
        data: () => ({
            companyError: null,
            roles: [
                {name: "Admin", value: ""},
                {name: "Normal", value: ""},
            ],
            modes: [
                {name: "prepay", value: true},
                {name: "postpay", value: false},
            ],
            resellers: [],
            payments: [
                {
                    value: "",
                    name: "",
                },
            ],
            company: {
                company_name: null,
                payment_term_uuid: null,
                credit: null,
                prepay: null,
                reseller_uuid: null,
                sms_per_sec: null,
                contact: {
                    email: null,
                    city: null,
                    first_name: null,
                    last_name: null,
                    zipcode: null,
                    country_uuid: null,
                    address: null,
                    phone: null,
                    logo_file_uuid: null,
                    passwd: null,
                },
            },
            file: null,
            countries: [],
            phone_number: null,
        }),
        created() {
            this.getResellerList();
            this.getCountries();
            this.getPaymentTermList();
        },
        methods: {
            transformReseller(item) {
                return {
                    name: item.reseller_name,
                    value: item.reseller_uuid,
                };
            },
            splitByThree(string) {
                const new_array = [];
                for (let i = 0; i < string.length; i += 3) {
                    new_array.push(string.slice(i, i + 3));
                }
                return new_array;
            },
            PhonePatternHendler(e) {
                // const value = e.replace(/[^0-9.]/gi, "");
                // const value = e
                // const value_array = this.splitByThree(value);
                //
                // this.phone_number = value_array.join("-");
            },
            getResellerList() {
                this.$store.dispatch("GetResellerList", {}).then((res) => {
                    const {total} = res;

                    this.$store
                        .dispatch("GetResellerList", {per_page: total})
                        .then((res) => {
                            console.log("res", res);
                            this.resellers = res.items.map(this.transformReseller);
                        });
                });
            },
            handleCompanyName(v) {
                this.company.company_name = this.$capitalize(v);
            },
            handleFirstName(v) {
                this.company.contact.first_name = this.$capitalize(v);
            },
            handleLastName(v) {
                this.company.contact.last_name = this.$capitalize(v);
            },
            async getCountries() {
                const {items} = await this.$store.dispatch("getCountryList", {
                    nice_name: this.countryName,
                });
                this.countries = items.map((i) => {
                    return {
                        name: i.nice_name ? i.nice_name : i.name,
                        value: i.country_uuid,
                    };
                });
            },
            async getPaymentTermList() {
                const {total} = await this.$store.dispatch("GetPaymentTerms", {});
                const {items} = await this.$store.dispatch("GetPaymentTerms", {
                    total,
                });

                this.payments = [
                    this.payments,
                    ...items.map((item) => {
                        return {
                            value: item.payment_term_uuid,
                            name: item.name ? item.name : "",
                        };
                    }),
                ];
            },
            addCompany: async function () {
                const valid = await this.$validator.validate();

                if (!valid) {
                    return;
                }

                try {
                    if (!this.company.reseller_uuid) {
                        delete this.company.reseller_uuid;
                    }
                    if (this.company.prepay === "true") {
                        delete this.company.payment_term_uuid;
                    }
                    if (!this.company.payment_term_uuid) {
                        delete this.company.payment_term_uuid;
                    }
                    if (!this.company.sms_per_sec) {
                        delete this.company.sms_per_sec
                    }
                    this.company.contact.phone = this.phone_number.replace(/[^0-9]/g, '');

                    await this.$store.dispatch("AddCompany", {
                        company: this.company,
                    });

                    this.$snotify.success("Company have been added.", {
                        timeout: 6000,
                    });

                    this.$router.push({name: "system-admin-company-list"});
                } catch (err) {
                    if (err.errors) {
                        this.companyError = err.errors[0].contact
                            ? err.errors[0].contact
                            : null;
                        setTimeout(() => {
                            this.companyError = null;
                        }, 6000);
                    } else if (err.response) {
                        this.$snotify.error(
                            err.response.data.errors
                                ? err.response.data.errors
                                : err.response.data.error.message,
                            {timeout: 6000}
                        );
                    } else {
                        this.$snotify.error(err, {timeout: 6000});
                    }
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .help {
        position: absolute;
        bottom: 3px;
    }

    .container-main {
        width: 100%;

        .container-1 {
            width: 100%;
            font-family: "Helvetica Neue";
            margin: 0 auto;
            padding: 0 20px;

            .add-navigation {
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100%;
                margin-top: 20px;
                margin-bottom: 20px;

                .back-link {
                    cursor: pointer;
                    display: flex;

                    align-items: center;
                    fill: #51a3f3;
                    color: #51a3f3;
                    font-family: "Helvetica Neue";
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 20px;

                    p {
                        margin-bottom: 0;
                        width: 135px;
                    }
                }

                .buttons-wrapper {
                    display: flex;
                    align-items: center;
                    width: fit-content;

                    .primary-button {
                        height: 40px;
                        width: 150px;
                    }

                    .secondary-button {
                        height: 40px;
                        width: 90px;
                        margin-right: 20px;
                    }
                }
            }

            .primary-input-container[data-v-2f08c06e] {
                width: 100%;
            }

            .primary-input-container[data-v-01567ff0] {
                width: 100%;
            }

            .add-container {
                flex-direction: column;
                align-items: center;
                height: fit-content;
                background-color: #ffffff;
                padding-top: 15px;

                .container-title {
                    height: 30px;
                    width: 432px;
                    color: #000000;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 30px;
                    padding: 15px 0 15px 15px;
                }

                .col-wrapper {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    // margin-left: 15px;
                    margin-top: 20px;

                    .col {
                        width: 100%;
                        padding-right: 15px;

                        .buttons-wrapper {
                            display: flex;
                            align-items: center;
                            width: fit-content;
                            width: 100%;

                            .state {
                                margin-right: 10px;
                            }

                            .credit {
                                margin-right: 10px;
                            }

                            .country {
                                margin-right: 10px;
                            }
                        }

                        .input {
                            margin-bottom: 20px;
                        }

                        .field {
                            p.pimary-input-title {
                                color: #000000;
                                font-family: "Helvetica Neue";
                                font-size: 12px;
                                font-weight: 900;
                            }
                        }

                        .upload-photo,
                        #dropzone {
                            min-height: 285px;
                            min-height: 285px;
                            border-radius: 4px;
                            width: 96%;

                            .dz-image {
                                padding: 5px;

                                img {
                                    height: 150px;
                                    width: 150px;
                                    border-radius: 50px;
                                }
                            }
                        }

                        .pimary-input-title {
                            color: #000000;
                            font-family: "Helvetica Neue";
                            font-size: 12px;
                            font-weight: 900;
                            letter-spacing: 0.21px;
                            line-height: 15px;
                            margin-bottom: 5px;
                            text-transform: uppercase;
                        }

                        .upload-contaioner {
                            border: 1px solid #5171f3;
                            border-radius: 4px;
                            background-color: #ffffff;
                            height: 265px;
                            border-style: dashed;
                            margin-right: 15px;
                            position: relative;

                            input[type="file"] {
                                position: absolute;
                                height: 36px;
                                width: 136px;
                                opacity: 0;
                                cursor: pointer;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                -ms-transform: translate(-50%, -50%); /* IE 9 fix */
                                z-index: 1;
                            }

                            .upload-button {
                                height: 36px;
                                width: 136px;
                                border-radius: 4px;
                                background-color: #51a3f3;
                                margin: 0;
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                            }
                        }
                    }
                }

                .email-input {
                    margin-bottom: 20px;
                }

                .password-input {
                    margin-bottom: 30px;
                }

                .first {
                    margin-bottom: 30px;

                    .remember-me {
                        display: flex;
                        align-items: center;

                        input {
                            margin-right: 5px;
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: 1420px) {
        .container-main {
            .container-1 {
                width: 100%;
            }
        }
    }

    .wrapper-buttons {
        display: flex;
        align-items: center;
        width: fit-content;
        width: 100%;

        .state {
            margin-right: 10px;
        }

        .credit {
            margin-right: 10px;
        }
    }

    .row .input {
        margin-bottom: 20px;
    }

    @media (max-width: 420px) {
        .button_parent_cont {
            display: unset;
        }

    }

    @media (max-width: 359px) {
        .secondary-button {
            min-width: 150px !important;
        }

    }
</style>

